import React from "react";
import { Chip } from "@mui/material";
import { ISSUE_CATEGORY_ORDER_INTENT, LIVECHAT_PARTNER_BRAND } from "./livechatConstants";
import { PASTEL } from "./livechatTheme";

/**
 * DEV-1421 — label kategori kendala mitra di list chat & header percakapan (sebelumnya hanya di panel
 * Info). Khusus channel mitra-purchasing; sesi tanpa kategori (mis. chat yang dimulai purchasing dari
 * Daftar Kontak) tidak menampilkan apa-apa. "Mau Orderan" diberi warna isi supaya menonjol.
 */
export default function IssueCategoryChip({ session, sx }) {
    if (session?.brand !== LIVECHAT_PARTNER_BRAND || !session.issueCategory) return null;
    const isOrderIntent = session.issueCategory === ISSUE_CATEGORY_ORDER_INTENT;
    return (
        <Chip
            size="small"
            label={session.issueCategory}
            variant={isOrderIntent ? "filled" : "outlined"}
            data-testid="issue-category-chip"
            sx={{
                height: 18,
                fontSize: 10,
                fontWeight: isOrderIntent ? 700 : 500,
                flexShrink: 0,
                "& .MuiChip-label": { px: 0.75 },
                ...(isOrderIntent
                    ? { backgroundColor: PASTEL.success, color: "#fff" }
                    : { color: "text.secondary", borderColor: PASTEL.border }),
                ...sx,
            }}
        />
    );
}
